import { ref, watchEffect } from "vue"
import { getUserTrail, pickTrail } from '@/api/trail'

const userTrail = ref(null)

export function useUserTrail () {
  watchEffect(async () => {
    if (!userTrail.value) {
      await fetchUserTrail()
    }
  })
  
  async function fetchUserTrail() {
    userTrail.value = await getUserTrail()
  }

  async function changeUserTrail(trailId) {
    return new Promise(async (resolver) => {
      const pickTrailResponse = await pickTrail(trailId)
      userTrail.value = pickTrailResponse.trail

      resolver()
    })
  }

  return { userTrail, changeUserTrail }
}